import FrontendHttpService from '@nmx/utils-frontend/dist/services/FrontendHttpService';

export const callImmediateMatchFeatureFlagService = async (config) => {
  const featureFlagId = '/NMX-Immediate-Match-FE';

  class UserDataHttpService {
    static async getFeatureFlag() {
      try {
        const response = await this.httpService.get(featureFlagId);
        return response;
      } catch (error) {
        console.error(`Error getting immediate match feature flag ${featureFlagId} with error: ${error}`);
        throw error;
      }
    }
  }

  UserDataHttpService.httpService = new FrontendHttpService({ baseURL: `${config.public.featureFlagBaseUrl}` });

  try {
    const response = await UserDataHttpService.getFeatureFlag();
    return response.featureEnabled;
  } catch (error) {
    return false;
  }
};

// function that awaits the promise from callImmediateMatchFeatureFlagService, and updates the feature flag state for the form
export const getImmediateMatchFeatureFlag = async (setImmediateMatchFeatureFlag, config) => {
  try {
    const result = await callImmediateMatchFeatureFlagService(config);
    setImmediateMatchFeatureFlag(result);
  } catch (error) {
    console.error(`error fetching immediate match feature flag with error: ${error}`);
  }
};

